module.exports = __webpack_public_path__ + "img/teacher-astronaut.1ee47472.png";